import Header from "./Header";
import "./styles/Gallery.css";
import { useState, useEffect } from "react";
import Footer from "./Footer";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

const galleryData = {
  livingRoom: [
    "/images/roomImages/dnevna1.webp",
    "/images/roomImages/dnevna2.webp",
    "/images/roomImages/dnevna3.webp",
    "/images/roomImages/dnevna4.webp",
    "/images/roomImages/dnevna5.webp",
    "/images/roomImages/dnevna6.webp",
    "/images/roomImages/dnevna7.webp",
    "/images/roomImages/detalj3.webp",
  ],
  kitchen: [
    "/images/roomImages/kuhinja1.webp",
    "/images/roomImages/kuhinja2.webp",
    "/images/roomImages/kuhinja3.webp",
    "/images/roomImages/detalj1.webp",
    "/images/roomImages/detalj2.jpeg",
  ],
  bedroom: [
    "/images/roomImages/spavaca1.webp",
    "/images/roomImages/spavaca2.webp",
  ],
  bathroom: [
    "/images/roomImages/kupatilo1.webp",
    "/images/roomImages/kupatilo2.webp",
  ],
  balcony: [
    "/images/roomImages/terasa1.webp",
    "/images/roomImages/terasa2.webp",
    "/images/roomImages/terasa3.webp",
    "/images/roomImages/terasa5.webp",
  ],
  exterior: [
    "/images/roomImages/objekat1.webp",
    "/images/roomImages/objekat2.webp",
  ],
};

const roomDetails = {
  livingRoom: { name: "Dnevni boravak", icon: "/images/livingRoom.png" },
  kitchen: { name: "Kuhinja", icon: "/images/kitchen.png" },
  bedroom: { name: "Spavaća soba", icon: "/images/bedroom.png" },
  bathroom: { name: "Kupatilo", icon: "/images/bathroom.png" },
  balcony: { name: "Terasa", icon: "/images/balcony2.png" },
  exterior: { name: "Objekat", icon: "/images/chalet.png" },
};

function Gallery() {
  const [selectedRoom, setSelectedRoom] = useState("livingRoom");
  const [enlargedImage, setEnlargedImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleImageClick = (src) => {
    setEnlargedImage(src);
  };

  const closeModal = () => {
    setEnlargedImage(null);
  };

  const changeRoom = (room) => {
    if (room !== selectedRoom) {
      setLoading(true);
      setTimeout(() => {
        setSelectedRoom(room);
        setLoading(false);
      }, 500);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          Galerija - Apartman Stari Vlah Zlatibor | Smeštaj i Pogled
        </title>
        <meta
          name="description"
          content="Pogledajte slike Apartmana Stari Vlah Zlatibor! Uživajte u fotografijama luksuznog smeštaja, prirode i prelepog pogleda sa Zlatibora."
        />
        <meta
          name="keywords"
          content="apartmani Zlatibor slike, smeštaj Zlatibor slike, apartman Zlatibor enterijer, Zlatibor planina slike, priroda Zlatibor, luksuzni apartmani Zlatibor, najbolji smeštaj Zlatibor, Zlatibor apartman pogled, smeštaj Zlatibor fotografije"
        />
      </Helmet>
      <Header />
      <div className="galleryHeadImgDiv">
        <img src="/images/roomImages/terasa5.webp" className="galleryHeadImg" />
        <motion.h2
          className="galleryFirstHeader"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1.3, ease: "easeOut" }}
        >
          Galerija
        </motion.h2>
        <h1 className="galleryNameHeader">Apartman Stari Vlah</h1>
        <motion.h3
          className="gallerySecondHeader"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1.3, ease: "easeOut" }}
        >
          Pogledajte kutak mira u srcu Zlatibora. Naš apartman je stvoren za vaš
          savršen odmor!
        </motion.h3>
      </div>
      <div className="mainGalleryDiv">
        <div className="gallery-nav">
          {Object.keys(galleryData).map((room) => (
            <button
              key={room}
              className={`gallery-btn ${selectedRoom === room ? "active" : ""}`}
              onClick={() => changeRoom(room)}
            >
              <img
                src={roomDetails[room].icon}
                alt={`Ikona za ${room}`}
                className="room-icon"
                loading="lazy"
              />
              <span>{roomDetails[room].name}</span>
            </button>
          ))}
        </div>

        {loading ? (
          <div className="loader">
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        ) : (
          <div className="gallery-grid">
            {galleryData[selectedRoom].map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`Galerija Stari Vlah Apartman Smestaj Zlatibor - ${
                  roomDetails[selectedRoom].name
                } ${index + 1}`}
                className="gallery-img"
                onClick={() => handleImageClick(src)}
                loading="lazy"
              />
            ))}
          </div>
        )}

        {enlargedImage && (
          <div className="image-modal" onClick={closeModal}>
            <div
              className="image-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="close-btn" onClick={closeModal}>
                Nazad
              </button>
              <img
                src={enlargedImage}
                alt="Uvećana slika Smeštaj na Zlatiboru"
                className="enlarged-img"
                loading="lazy"
              />
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}

export default Gallery;
